import React, { useCallback, useMemo } from "react";
import { List as ListDisplay } from "stentor-models/lib/Display";
import { Carousel } from "../components/Carousel";
import { ChatMessagePart } from "../components/ChatMessagePart";
import { List } from "../components/List";
import { useButtonCallback, useExecuteActionCallback } from "../hooks";
import { isList } from "../utils/guards";
import { convertFromListDisplay } from "../utils/responseToMessage";
import { ChatServerList } from "../xapp/ChatServerMessage";
import { MessageMiddlewareBuilder, MessageMiddlewareFC } from "./message-middleware";

export const ListMiddlewareWidget: MessageMiddlewareFC<ListDisplay> = (props) => {
    const { msg, ctx } = props;

    if (!ctx) {
        throw new TypeError(`ctx not provided to ${ListMiddlewareWidget.name}`);
    }

    const list = useMemo<ChatServerList>(() => convertFromListDisplay(msg), [msg]);

    const executeActionCallback = useExecuteActionCallback();

    const handleExecute = useCallback(
        (ui: "carousel" | "list", text: string, token?: string) => {
            executeActionCallback(text, { token, action: "click", ui });
        },
        [executeActionCallback]
    );

    const handleButton = useButtonCallback();

    const user = ctx.user;

    return (
        <ChatMessagePart showAvatar={false} user={user}>
            {list.type === "CAROUSEL" && (
                <div className="chat-msg chat-msg--fullwidth chat-msg--no-ava">
                    <Carousel
                        list={list}
                        onExecute={handleExecute.bind(null, "carousel")}
                        onButtonClick={handleButton}
                        onOpenUrl={ctx.openUrl}
                    />
                </div>
            )}
            {list.type === "LIST" && (
                <div className="chat-msg chat-msg--expand">
                    <List
                        list={list}
                        onExecute={handleExecute.bind(null, "list")}
                        onButtonClick={handleButton}
                        onOpenUrl={ctx.openUrl}
                    />
                </div>
            )}
        </ChatMessagePart>
    );
};

export const ListMiddleware: MessageMiddlewareBuilder = (next) => (props) => {
    const { msg, ctx } = props;

    if (isList(msg)) {
        return <ListMiddlewareWidget msg={msg} ctx={ctx} />;
    }

    return next(props);
};
